export const mapRoutesClients = {
    "atendimento": {
        ticketType: [121, 122],
        openTicketType: 121
    }, 
    "monitoramento":{
        ticketType: [49],
        openTicketType: 49
    } 
}
